export default __webpack_public_path__ + "static/media/03-icon-verpackung.ec25622e.svg";